import { useFetchInvoice } from '@/hooks/useFetchInvoice';
import { Link, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

interface IInvoiceProps {
  id: string;
}

export const InvoiceDownload: React.FC<IInvoiceProps> = ({ id }): JSX.Element => {
  const { hasError, invoiceUrl, isLoading } = useFetchInvoice(id);
  const { t } = useTranslation();

  if (isLoading)
    return (
      <Text color="brand.red.light" fontSize={18} fontWeight="bold">
        {t('SHIPMENT_DETAILS.INVOICE_LOADING')}
      </Text>
    );

  if (hasError)
    return (
      <Text color="brand.red.light" fontSize={18} fontWeight="bold">
        {t('SHIPMENT_DETAILS.INVOICE_NOT_AVAILABLE')}
      </Text>
    );

  return (
    <Link
      color="brand.red.light"
      fontSize={18}
      fontWeight="bold"
      href={invoiceUrl?.url}
      target="_blank"
    >
      {t('SHIPMENT_DETAILS.INVOICE_DOWNLOAD')}
    </Link>
  );
};
